import { FormInputElementWithOptions } from '@typedream/core';
import { setNodes, TNodeEntry } from '@udecode/plate-core';
import { DreamEditor } from '../../../types';
import { FormEditor } from '../types';

export const normalizeFormInputOptions = (
  editor: DreamEditor,
  entry: TNodeEntry<FormInputElementWithOptions>,
) => {
  const e = editor as FormEditor;
  const [node, path] = entry;
  if (node.options && Array.isArray(node.options)) {
    // make sure that all the options have proper id.
    let currentIndex = -1;
    if (e.currentNameToOptionsMap[node.name]) {
      Object.keys(e.currentNameToOptionsMap[node.name]).forEach((v) => {
        if (parseInt(v, 10) > currentIndex) currentIndex = parseInt(v, 10);
      });
    } else {
      e.currentNameToOptionsMap[node.name] = {};
    }

    const valueDefinedOptions = node.options.filter((opt) => typeof opt.value !== 'undefined');
    valueDefinedOptions.forEach((opt) => {
      e.currentNameToOptionsMap[node.name][opt.value] = {
        name: opt.label,
      };
    });

    const valueUndefinedOptions = node.options.filter((opt) => typeof opt.value === 'undefined');

    let dirty = false;
    const nodeOptions = [
      ...valueDefinedOptions,
      ...valueUndefinedOptions.map((opt) => {
        const optClone = { ...opt };
        currentIndex += 1;
        optClone.value = currentIndex;
        e.currentNameToOptionsMap[node.name][currentIndex] = {
          name: opt.label,
        };
        dirty = true;
        return optClone;
      }),
    ];

    // cleanup deleted options in the current node
    const nodeOptionKeys = nodeOptions.map(({ value }) => value.toString());
    const deleteKeys = Object.keys(e.currentNameToOptionsMap[node.name])
      .filter((key) => !e.currentNameToOptionsMap[node.name][parseInt(key, 10)].deleted)
      .filter((key) => nodeOptionKeys.findIndex((val) => val === key) === -1);
    deleteKeys.forEach((key) => delete e.currentNameToOptionsMap[node.name][parseInt(key, 10)]);

    if (dirty) {
      setNodes(e, {
        options: nodeOptions,
      }, {
        at: path,
      });
      return true;
    }
  }
  return false;
};
